import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetUserProfile from '../../common/category/useGetUserProfile'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { selectListQuestion, selectLoadingQuestion } from '../store/slice'

const QuestionSuggest = ({ sendUserMessage, isChangeLayout }) => {
  const loading = useSelector(selectLoadingQuestion)
  const listQuestion = useSelector(selectListQuestion)
  const { userProfile } = useGetUserProfile()

  return (
    <div className="welcome-section-suggested">
      <div className="welcome-section">
        <div
          className="welcome-title"
          style={{
            fontSize: isChangeLayout ? 20 : 22,
            fontWeight: 700,
            color: '#034ea2',
            textAlign: 'center',
            lineHeight: 1.3,
          }}
        >
          <div>
            <Translate value="chatbot.HELLO_CHATBOT_1_GREETING" />
          </div>
          {userProfile?.fullName && (
            <div
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-word',
              }}
              title={userProfile.fullName}
            >
              {userProfile.fullName}
            </div>
          )}
        </div>
        <Element
          style={{ fontSize: isChangeLayout ? 14 : 16, marginTop: 4 }}
          className="welcome-subtitle"
        >
          <Translate value="chatbot.HELLO_CHATBOT_2" />
        </Element>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <Element className="suggested-actions">
          {listQuestion.map((item, index) => (
            <Element
              key={index}
              style={{ fontSize: 14 }}
              className="suggestion-card"
              onClick={() => sendUserMessage(item?.questionContent)}
            >
              {item?.questionContent}
            </Element>
          ))}
        </Element>
      )}
    </div>
  )
}

export default QuestionSuggest
